import { OrderKeys } from '~src/spacesPlatform/models/OrderKeys';
import { SortOptions } from '~src/spacesPlatform/models/sort/CommonSortOptions';
import { OptionsDictionary } from '~src/spacesPlatform/models/sort/SortOptionDefinitions';
//import { createNonDisplayOptionDefinition } from '~src/spacesPlatform/models/sort/SortOptionsHelper';

export const geocodingTasksSortOptions: OptionsDictionary = {
  // TODO: @W-16252694 enable sorting by the other columns
  //[OrderKeys.geocodingConfigName] : createNonDisplayOptionDefinition(OrderKeys.geocodingConfigName, OrderKeys.geocodingConfigName),
  //[OrderKeys.lastRunAt]: SortOptions.lastRunAt,
  [OrderKeys.runNextAt]: SortOptions.runNextAt,
};